import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateCustomBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.createCustomBadge,
  {
    mutationKey: ['createCustomBadge'],
  },
)
